import { render, staticRenderFns } from "./LmPassword.vue?vue&type=template&id=2e6d4678&scoped=true&"
import script from "./LmPassword.vue?vue&type=script&lang=js&"
export * from "./LmPassword.vue?vue&type=script&lang=js&"
import style0 from "./LmPassword.vue?vue&type=style&index=0&id=2e6d4678&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6d4678",
  null
  
)

export default component.exports